/**
 * Exécution différée au chargement complet de la page.
 *
 * Sert à sortir du chemin critique ce qui n'a pas à y être — d'abord l'enregistrement du
 * Service Worker (`src/main.tsx`) : `navigator.serviceWorker.register()` met aussitôt en
 * file le précache de tout l'*app shell*, et sur la 4G d'un chantier ces requêtes
 * concurrencent celles du premier rendu. C'est la recommandation Workbox.
 *
 * ⚠️ `load` ne se rejoue pas : un écouteur posé après coup ne se déclencherait **jamais**
 * — l'app ne serait alors jamais précachée, donc plus utilisable hors réseau
 * (`docs/ARCHITECTURE.md` **D22**). Le cas n'est pas théorique dès qu'un script est
 * différé ou qu'un module met du temps à arriver. D'où la lecture de
 * `document.readyState` : chargement déjà `complete`, on exécute sur place.
 */
export function runAfterPageLoad(task: () => void): void {
  if (document.readyState === 'complete') {
    task()
    return
  }

  window.addEventListener('load', () => task(), { once: true })
}
